import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { HomepagelocalService } from '../countryhome.service';
import { CommonModule } from '@angular/common';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';

@Component({
  selector: 'app-features-section',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.scss'],
  imports: [CommonModule, ToHtmlPipe],
})
export class FeaturesSectionComponent implements OnInit {
  @Input() pageData:any;
  hasInside = false;
  constructor(private homePageService: HomepagelocalService) {}

  featuresData: any;

  ngOnInit(): void {
    const data = this.pageData?.features?.[0]?.fields;
    this.hasInside = !this.pageData?.whitepaperAndReportsArticle;
    if (data) {
      this.featuresData = data;
    }
  }
  ngOnChanges(): void {
    const data = this.pageData?.features?.[0]?.fields;
    this.hasInside = !this.pageData?.whitepaperAndReportsArticle;
    if (data) {
      this.featuresData = data;
    }
  }
}
